/* Types */
interface StringWithId {
  id: string;
  value: string;
}

export interface ItemsWithHeader<TItem> {
  header: StringWithId;
  items: TItem[];
}

const latinLetterRegExp = /^[a-z]/i;
export const pushOrInitialize = <TItem>(arr: TItem[], item: TItem) => {
  if (arr) {
    arr.push(item);
    return arr;
  }
  return [item];
};

export const sortNamedObjectsAlphabetically = <TItem extends StringWithId>(
  items: TItem[],
): ItemsWithHeader<TItem>[] => {
  if (!items) {
    return [];
  }

  const data = items.reduce((accumulator: Record<string, TItem[]>, item: TItem) => {
    let key = item.value[0].toLowerCase();
    if (!key.match(latinLetterRegExp)) {
      key = '0-9';
    }

    accumulator[key] = pushOrInitialize(accumulator[key], item);
    return accumulator;
  }, {});

  const result: ItemsWithHeader<TItem>[] = [];
  Object.entries(data).forEach(([header, itemTexts]: [string, TItem[]]) => {
    const sortedItemTexts = itemTexts.sort((left, right) => {
      return left.value.localeCompare(right.value, 'en-US');
    });
    result.push({ header: { id: header, value: header }, items: sortedItemTexts });
  });

  result.sort(({ header: left }, { header: right }) => {
    return left.value.localeCompare(right.value, 'en-US');
  });

  return result;
};
